<template>
  <v-container class="px-0" fluid>
    <validation-observer ref="textInput">
      <v-row class="py-0">
        <v-col cols="12" sm="4" class="py-0">
          <CustomTelInput
            header="Phone Number"
            placeholder="+# (###) ###-####"
            :value="contact.phone"
            :maxlength="150"
            @input="(val) => $emit('input', val, 'phone')"
          />
        </v-col>
        <v-col cols="12" sm="4" class="py-0">
          <CustomTextInput
            header="Fax Number"
            :value="contact.fax"
            :maxlength="150"
            @input="(val) => $emit('input', val, 'fax')"
          />
        </v-col>
      </v-row>
    </validation-observer>

    <v-row class="mt-12">
      <v-col cols="12" class="d-flex justify-end flex-wrap">
        <v-btn
          class="custom-button custom-button--gray px-11 mr-sm-5 mb-4 mb-sm-0"
          height="34px"
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          @click="$emit('prev-step')"
        >
          <v-icon class="pr-1" size="15">
            mdi-arrow-left
          </v-icon>
          Previous
        </v-btn>
        <v-btn
          class="custom-button custom-button--blue px-8"
          height="34px"
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          @click="createContact()"
        >
          Create contact
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomTextInput from "@/sharedComponents/CustomTextInput";
import CustomTelInput from "@/sharedComponents/CustomTelInput";

export default {
  name: "Step3",
  components: {
    CustomTextInput,
    CustomTelInput,
  },
  props: {
    contact: {
      default: () => {},
    },
  },
  methods: {
    async validate() {
      return await this.$refs.textInput.validate();
    },
    reset() {
      this.$refs.textInput.reset();
    },
    resetValidation() {
      this.$refs.textInput.resetValidation();
    },
    async createContact() {
      try {
        if (await this.validate()) {
          this.$emit('create-contact')
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style scoped>
::v-deep .custom-text-input .field__subheader,
::v-deep .custom-date-picker .field__subheader {
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #241c15;
}
</style>
